module.exports={
    "Uplive注册验证": "Uplive注册验证",
    "两次输入的密码必须一致": "两次输入的密码必须一致",
    "取消": "取消",
    "如验证出现问题，请点击": "如验证出现问题，请点击",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "如验证出现问题，请联系orcalivecs@asiainnovations.com",
    "如验证出现问题，请联系upcs@asiainnovations.com": "如验证出现问题，请联系upcs@asiainnovations.com",
    "密码修改成功": "密码修改成功",
    "密码格式错误": "密码格式错误",
    "密码由6-20位由数字和字母组成": "密码由6-20位由数字和字母组成",
    "恭喜您密码重置成功": "恭喜您密码重置成功",
    "恭喜您已成功激活帐户": "恭喜您已成功激活帐户",
    "恭喜您已成功激活账户，赶快返回Uplive中与全球潮人互动吧": "恭喜您已成功激活账户，赶快返回Uplive中与全球潮人互动吧",
    "此链接30分钟内有效，超时请返回应用重新发送": "此链接30分钟内有效，超时请返回应用重新发送",
    "知道了": "知道了",
    "确认修改": "确认修改",
    "确认验证": "确认验证",
    "网络连接有误, 请稍后再试": "网络连接有误, 请稍后再试",
    "联系客服": "联系客服",
    "请再次输入密码": "请再次输入密码",
    "请输入正确的验证码": "请输入正确的验证码",
    "请返回UpVoice中重新进行邮箱验证": "请返回UpVoice中重新进行邮箱验证",
    "请返回Up直播中重新进行邮箱验证": "请返回Up直播中重新进行邮箱验证",
    "请返回虎鲸直播中重新进行邮箱验证": "请返回虎鲸直播中重新进行邮箱验证",
    "请重新设定登录密码": "请重新设定登录密码",
    "请重新设置密码": "请重新设置密码",
    "赶快返回UpVoice中与全球潮人互动吧": "赶快返回UpVoice中与全球潮人互动吧",
    "赶快返回Up直播中与全球潮人互动吧！": "赶快返回Up直播中与全球潮人互动吧！",
    "赶快返回虎鲸直播中与全球潮人互动吧": "赶快返回虎鲸直播中与全球潮人互动吧",
    "输入图片中的验证码": "输入图片中的验证码",
    "重置密码失败": "重置密码失败",
    "验证失败": "验证失败",
    "验证失败，请返回Uplive中重新进行邮箱验证": "验证失败，请返回Uplive中重新进行邮箱验证",
    "验证成功": "验证成功"
};


// WEBPACK FOOTER //
// ./js/lang/zhcn.js